import React from 'react'
import { Link } from "react-router-dom";

export default function Footer(props) {
  return (
    <div className='footer'>
        <div className='footer-container'>
            <div className='footer-section1'>
                <h2 className='logo' >{props.logo}</h2>
                <p>Begin your transformation today with Panada Fitness, where expert guidance and dedication help you conquer challenges and achieve lasting success.</p>
                <div className='socials'>
                    <a href='#'>
                        <div class="icon-container"
                            style={{
                            '--icon-url': "url('/images/youtube.png')",
                            }}
                        ></div>
                    </a>
                    <a href='https://wa.me/9082955754?text=Hello%20there!'>
                        <div class="icon-container"
                            style={{
                            '--icon-url': "url('/images/whatsapp.png')",
                            }}
                        ></div>
                    </a>
                    <a href='#'>
                        <div class="icon-container"
                            style={{
                            '--icon-url': "url('/images/instagram.png')",
                            }}
                        ></div>
                    </a>
                    <a href='#'>
                        <div class="icon-container"
                            style={{
                            '--icon-url': "url('/images/facebook.png')",
                            }}
                        ></div>
                    </a>
                </div>
            </div>
            <div className='footer-section2'>
                <p className='footer-menuh'>MENU</p>
                <p className='footer-menu'></p>
                <Link to ="/" className='footer-menu'>Home</Link>
                <Link to ="/about" className='footer-menu'>About</Link>
                <Link to ='/team' className='footer-menu'>Our Team</Link>
                <Link to ='/courses' className='footer-menu'>Courses</Link>
                <Link to ='/contact' className='footer-menu'>Contacts</Link>                
            </div>
            <div className='footer-section3'>
                <div className='footer3-innerbox'>
                    <div class="icon-container"
                        style={{
                        '--icon-url': "url('/images/gym.png')",
                        }}
                    ></div>
                    <p>Shop no. 12, Progressive Sea Lounge, 44, opposite Belapur Jetty, Sector 15, CBD Belapur, Maharashtra 400614</p>
                </div>
                <div className='footer3-innerbox'>
                    <div class="icon-container"
                        style={{
                        '--icon-url': "url('/images/phone-call.png')",
                        }}
                    ></div>
                    <p>090829 55754</p>
                </div>
                <div className='footer3-innerbox'>
                    <div class="icon-container"
                        style={{
                        '--icon-url': "url('/images/email.png')",
                        }}
                    ></div>
                    <p>panada.fitness@gmail.com</p>
                </div>
            </div>
        </div>
        <p className='copyrights'>© 2024 Panada Fitness. All rights reserved.</p>
    </div>
  )
}